import type { TFunction } from 'i18next';

import type {
  ApplicationStatus,
  CoverageStatus,
  PrayerSlot,
  UserRole,
  Weekday,
} from '@/shared/model/enums';

const cap = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);

export const roleLabel = (t: TFunction, role: UserRole): string => t(`roles.${role}`);
export const roleDescription = (t: TFunction, role: UserRole): string => t(`roles.${role}Desc`);
export const prayerLabel = (t: TFunction, prayer: PrayerSlot): string => t(`prayers.${prayer}`);
export const weekdayLabel = (t: TFunction, weekday: Weekday): string => t(`weekdays.${weekday}`);

export const coverageStatusLabel = (t: TFunction, status: CoverageStatus): string =>
  t(`coverage.status${cap(status)}`);

export const applicationStatusLabel = (t: TFunction, status: ApplicationStatus): string =>
  t(`application.status${cap(status)}`);

/** Semantic color token for a coverage status. */
export const coverageStatusColor = (status: CoverageStatus): string => {
  switch (status) {
    case 'open':
      return 'var(--color-success)';
    case 'filled':
      return 'var(--color-primary)';
    case 'cancelled':
      return 'var(--color-danger)';
    case 'expired':
      return 'var(--color-on-surface-muted)';
  }
};

/** Semantic color token for an application status. */
export const applicationStatusColor = (status: ApplicationStatus): string => {
  switch (status) {
    case 'pending':
      return 'var(--color-accent-text)';
    case 'accepted':
      return 'var(--color-success)';
    case 'rejected':
      return 'var(--color-danger)';
    case 'withdrawn':
      return 'var(--color-on-surface-muted)';
    case 'completed':
      return 'var(--color-primary)';
    case 'no_show':
      return 'var(--color-danger)';
  }
};
